import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Countries } from './countries.model';

@Injectable({
    providedIn: 'root',
})
export class CountryService {
    private jsonURL = 'assets/countries.json';
  
    constructor(private http: HttpClient) {}
  
    getCountries(): Observable<Countries[]> {
      return this.http.get<Countries[]>(this.jsonURL);
    }
  }